import { memo } from "react";
import { t } from "@/i18n-js/instance";
import { Radio } from "@/react/components/shared/uikit/Radio";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { annualDiscountPercentage } from "@/react/helpers/planHelpers";
import type { RadioOptionProps } from "./types";

const LOCALE_ROOT = "pricing_plans.plan_settings.plan_summary";

export const AnnualRadioOption = memo<RadioOptionProps>(
  ({ id, interval, isSelected, onIntervalChange, plan }) => (
    <Radio
      id={id}
      name="billing-interval"
      label={
        <div className="flex flex-row items-center gap-2">
          <Typography.LabelSm weight="semibold">
            {t([LOCALE_ROOT, "annual_billing"])}
          </Typography.LabelSm>
          {plan && (
            <div className="flex items-center rounded-md bg-green-50 px-2 py-0.5">
              <Typography.LabelXs weight="medium" color="text-green-700">
                {t([LOCALE_ROOT, "annual_savings"], {
                  percentage: annualDiscountPercentage(plan),
                })}
              </Typography.LabelXs>
            </div>
          )}
        </div>
      }
      value={interval}
      description={
        <Typography.BodySm weight="normal">
          {t([LOCALE_ROOT, "plan_annual_amount"], {
            amount: plan?.display_base_monthly_amount,
          })}
        </Typography.BodySm>
      }
      defaultChecked={isSelected}
      onChange={() => onIntervalChange(interval)}
    />
  ),
);

AnnualRadioOption.displayName = "AnnualRadioOption";
